/* eslint-disable @typescript-eslint/no-unused-vars */
export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e: any) {
    return false;
  }
  return true;
}

export function safeJSONparse<T>(data: any) {
  if (data === 'undefined') return undefined;
  if (data === 'null') return null;
  if (data === 'true') return true as T;
  if (data === 'false') return false as T;

  return (isJsonString(data) ? JSON.parse(data) : data) as T;
}
